import React, { useState, useEffect, PureComponent } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../assets/players.css";
import StatsTab from "../components/Players/StatsTab";
import GamesTab from "../components/Players/GamesTab";
import BioTab from "../components/Players/BioTab";
import AnalysisTab from "../components/Players/AnalysisTab";
import VideosTab from "../components/Players/VideosTab";
import OverviewTab from "../components/Players/OverviewTab";
import IntelTab from "../components/Players/IntelTab";
import axios from "axios";
import { toast } from "react-toastify";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts"; // Importing Recharts for gauge wheel
import Xfactor from "../components/Players/Xfactor";
import { getRandomProfileImage } from "../components/Utils/functions";
import {
  getRandomNumber,
  sim_player_wording,
} from "../components/Utils/functions";
import PageContainer from "./PageContainer";
import { useMobileCheck } from "../components/Utils/functions";
import NotificationsModal from "../components/Players/Notifications";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Dialog from "@mui/material/Dialog";
import NILChart from "../components/Analysis/NILChart";
// Sample data for player
const playerData = {
  overview: {
    id: 1,
    jersey: 15,
    name: "",
    image: "https://s3media.247sports.com/Uploads/Assets/48/387/12387048.jpeg",
    position: "F",
    age: "21",
    height: "6'5",
    weight: "189 lbs",
    class: "Senior",
    rank: "12",
    nilValue: "450k",
    overallScore: 77, // Overall score for the gauge wheel
    latest: {
      game: "Opponent played",
      date: "11/2/24",
      mins: 16,
      pts: 22,
      reb: 2,
      ast: 3,
      stl: 0,
      blk: 0,
      to: 1,
      pf: 2,
      fg: "5/12",
    },
  },
  analysis: {
    ball_handling: 85,
    scoring: 80,
    rebounding: 75,
    defense: 70,
    playmaking: 65,
  },
  games: {},
  bio: {},
  highlights: {
    youtube: ["https://www.youtube.com/embed/c1hUSWeaeTs"],
    tiktok: [
      "https://www.tiktok.com/player/v1/7440122787613723936",
      "https://www.tiktok.com/player/v1/7435636908018978081",
    ],
    instagram: [],
  },
  intel: [
    {
      title:
        "A look at the Los Angeles Times’ top 25 high school boys’ basketball teams",
      content:
        "A look at the Los Angeles Times’ top 25 high school boys’ basketball teams in the Southland heading into the 2023-24 season.",
      image:
        "https://ca-times.brightspotcdn.com/dims4/default/766f724/2147483647/strip/true/crop/3000x2216+0+0/resize/1200x886!/quality/75/?url=https%3A%2F%2Fcalifornia-times-brightspot.s3.amazonaws.com%2Fee%2F7e%2F978a9e25458b9692368aa7875b59%2Fbosco.jpg",
      link: "https://www.latimes.com/sports/highschool/story/2023-11-05/la-times-top-25-high-school-basketball-rankings-preseason",
      date: "11/05/2023",
      source: "Los Angeles Times",
    },
    {
      title:
        "Ranking the top 15 high school basketball players in the 2025 class",
      content:
        "The AAU season is in the distant rearview, and most of the nation's best are preparing to suit up for their final season of high school ball. While some players have reclassified and are already enrolled at their respective colleges, the 2025 class is still highly touted with future NBA prospects.",
      image:
        "https://www.usatodayhss.com/gcdn/authoring/authoring-images/2024/10/20/SHSS/75770104007-usatsi-22142841.jpg?crop=4537,2552,x0,y0&width=3200&height=1800&format=pjpg&auto=webp",
      link: "https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.usatodayhss.com%2Fstory%2Fsports%2Fhigh-school%2Fboys-basketball%2F2024%2F10%2F21%2Fbasketball-recruiting-rankings-top-players-2025-class%2F75768567007%2F&psig=AOvVaw3wLxjzKLZp1Knt-9RCBTV5&ust=1735273084205000&source=images&cd=vfe&opi=89978449&ved=0CBQQjRxqFwoTCMjj8pLKxIoDFQAAAAAdAAAAABAJ",
      date: "10/21/2024",
      source: "USA Today",
    },
  ],
  similarPlayers: [
    {
      name: "John Doe",
      image: getRandomProfileImage(),
      position: "F",
      ball_handling: 85,
      scoring: 80,
      rebounding: 75,
      defense: 70,
      playmaking: 65,
      school: "University of California, Los Angeles",
      content:
        "Tremendous physical build for a wing. Has explosive athleticism and can make plays in traffic. Loves to attack the rim. Has a powerful spin move to finish off drives. Shoots it well enough from deep but an area for improvement. Handles well in space but needs to tighten and refine his handle. Can deliver a pass on the move. Active player who comes up with balls off the glass and the floor. Has great potential as a multi positional defender.",
    },
    {
      name: "John Doe",
      image: getRandomProfileImage(),
      position: "F",
      ball_handling: 85,
      scoring: 80,
      rebounding: 75,
      defense: 70,
      playmaking: 65,
      school: "University of California, Los Angeles",
      content:
        "This is a test content about why this player is similar to the player you are looking at",
    },
    {
      name: "John Doe",
      image: getRandomProfileImage(),
      position: "F",
      ball_handling: 85,
      scoring: 80,
      rebounding: 75,
      defense: 70,
      playmaking: 65,
      school: "University of California, Los Angeles",
      content:
        "This is a test content about why this player is similar to the player you are looking at",
    },
  ],
};

const SinglePlayer = () => {
  const isMobile = useMobileCheck();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Overview");
  // Prepare gauge wheel data
  const RADIAN = Math.PI / 180;

  // Move data and value into state
  const [data, setData] = useState([]);
  const [value, setValue] = useState(0);
  const [playerBaseline, setPlayerBaseline] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needleAngle, setNeedleAngle] = useState(0); // Starts at 180 degrees
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [isTracking, setIsTracking] = useState(false);

  useEffect(() => {
    const minValue = 50;
    const maxValue = 100;
    const totalValue = maxValue - minValue;

    // Map value to angle between -90 and 90 degrees
    const finalAngle = ((value - minValue) / totalValue) * 180 - 90;

    // Delay the update to ensure initial render occurs with angle -90 degrees
    const timer = setTimeout(() => setNeedleAngle(finalAngle), 100);

    return () => clearTimeout(timer);
  }, [value]);

  useEffect(() => {
    // Fetch player list
    axios
      .get(`/api/players/${id}`)
      .then((response) => {
        console.log(response.data);
        setPlayerBaseline(response.data);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to load players");
      });
  }, []);

  useEffect(() => {
    // Find the scrollable container
    const scrollableContainer = document.querySelector(
      '[style*="overflow: auto"]'
    );
    if (scrollableContainer) {
      scrollableContainer.scrollTop = 0;
    }
  }, [id, location.pathname]);

  useEffect(() => {
    if (playerBaseline?.player_id) {
      const savedSettings = localStorage.getItem(
        `notificationSettings_${playerBaseline.player_id}`
      );
      if (savedSettings) {
        const settings = JSON.parse(savedSettings);
        // Check if any notification is enabled
        setIsTracking(Object.values(settings).some((value) => value));
      }
    }
  }, [playerBaseline?.player_id, notificationsOpen]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "Overview":
        return (
          <OverviewTab
            data={playerData.overview}
            playerBaseline={playerBaseline}
            similarPlayers={playerData.similarPlayers}
          />
        );
      case "Stats":
        return <StatsTab player={playerBaseline} stats={playerData.stats} />;
      case "Box Scores":
        return <GamesTab player={playerBaseline} />;
      case "Bio":
        return <BioTab />;
      case "Analysis":
        return <AnalysisTab analysis={playerBaseline} />;
      case "Highlights":
        return <VideosTab highlights={playerData.highlights} />;
      case "Intel":
        return (
          <IntelTab intel={playerData.intel} playerBaseline={playerBaseline} />
        );
      case "NIL":
        return <NILChart player={playerBaseline} />;
      default:
        return (
          <OverviewTab
            data={playerData.overview}
            playerBaseline={playerBaseline}
            similarPlayers={playerData.similarPlayers}
          />
        );
    }
  };

  useEffect(() => {
    setData([
      { name: "NAIA/Juco", value: 15, color: "#EF426F" },
      { name: "Div II/III", value: 11, color: "#F2853C" },
      { name: "Division 1", value: 10, color: "#F7DC62" },
      { name: "High Major", value: 8, color: "#54CE3C" },
      { name: "NBA Prospect", value: 6, color: "#368911" },
    ]);

    // Replace random number with xfactor from playerBaseline
    const xfactorValue = parseInt(playerBaseline?.xfactor, 10);
    setValue(xfactorValue || 50); // Fallback to 50 if xfactor is not available
  }, [playerBaseline]); // Add playerBaseline as dependency

  const cx = 100;
  const cy = 100;
  const iR = 40;
  const oR = 100;

  const needle = (cx, cy, iR, oR, color, needleAngle) => {
    const length = (iR + 2 * oR) / 3; // Adjust as needed for your design

    return (
      <g
        style={{
          transform: `rotate(${needleAngle}deg)`,
          transformOrigin: `${cx}px ${cy}px`,
          transition: "transform 1s ease-out",
        }}
      >
        <line
          x1={cx}
          y1={cy}
          x2={cx}
          y2={cy - length} // Pointing upwards
          stroke={color}
          strokeWidth={4}
        />
        <circle cx={cx} cy={cy} r={5} fill={color} />
      </g>
    );
  };

  const scoreUpdated = (
    <div className="score-last-updated">Score updated: Last updated date</div>
  );
  const playerName = (
    <h1 className="single-player-name">{playerBaseline?.player_name || ""}</h1>
  );
  return (
    <PageContainer>
      <div className="single-player-container">
        <div className="single-player-header">
          <img
            src={playerBaseline?.image_url || ""}
            alt={playerBaseline?.name}
            className="single-player-image"
          />
          {isMobile && playerName}

          <div className="single-player-gauge">
            {loading ? (
              // Placeholder div with same dimensions
              <div style={{ width: "210px", height: "110px" }} />
            ) : (
              <>
                <div className="single-player-gauge-xfactor">
                  <Xfactor score={value.toString()} placement={"profile"} />
                </div>
                <div
                  style={{
                    width: isMobile ? "250px" : "210px",
                    height: "110px",
                  }}
                >
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie
                        dataKey="value"
                        startAngle={180}
                        endAngle={0}
                        data={data}
                        cx={cx}
                        cy={cy}
                        innerRadius={iR}
                        outerRadius={oR}
                        fill="#8884d8"
                        stroke="none"
                        isAnimationActive={true}
                        animationDuration={800}
                      >
                        {data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      {/* Add the Needle component */}

                      {/* {needle(value, data, cx, cy, iR, oR, "#fff")} */}
                      {needle(cx, cy, iR, oR, "#fff", needleAngle)}
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </>
            )}
          </div>
          {isMobile && scoreUpdated}
          {/* Legend */}
          <div className="single-player-legend-container">
            <div className="single-player-legend">
              <ul>
                <li>
                  <span style={{ backgroundColor: "#EF426F" }}></span> NAIA/Juco
                  (50-65)
                </li>
                <li>
                  <span style={{ backgroundColor: "#F2853C" }}></span> Div
                  II/III (66-76)
                </li>
                <li>
                  <span style={{ backgroundColor: "#F7DC62" }}></span> Division
                  1 (77-88)
                </li>
                <li>
                  <span style={{ backgroundColor: "#54CE3C" }}></span> High
                  Major (87-94)
                </li>
                <li>
                  <span style={{ backgroundColor: "#368911" }}></span> NBA
                  Prospect (95-100)
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="single-player-info">
          {!isMobile && playerName}

          <div className="follow-player">
            <button
              className={`follow-player-button ${isTracking ? "tracking" : ""}`}
              onClick={() => setNotificationsOpen(true)}
            >
              {isTracking ? (
                <>
                  <CheckCircleIcon
                    sx={{ marginRight: "4px", fontSize: "12px" }}
                  />
                  Tracking
                </>
              ) : (
                "Track Player"
              )}
            </button>
            <button
              style={{
                background:
                  "linear-gradient(90deg, rgb(84 206 60) 0%, rgb(54 137 17) 100%)",
              }}
              className={`follow-player-button`}
              onClick={() => {
                const pid = playerBaseline?.player_id;
                const pname = playerBaseline?.player_name;
                const params = new URLSearchParams();
                if (pid) params.set("playerId", pid);
                else if (pname) params.set("playerName", pname);
                navigate(`/comparison?${params.toString()}`);
              }}
            >
              Compare
            </button>
            <NotificationsModal
              open={notificationsOpen}
              onClose={() => setNotificationsOpen(false)}
              playerId={playerBaseline?.player_id}
            />
          </div>
        </div>

        <div className="tabs">
          <button
            className={activeTab === "Overview" ? "active" : ""}
            onClick={() => setActiveTab("Overview")}
          >
            Overview
          </button>
          <button
            className={activeTab === "Stats" ? "active" : ""}
            onClick={() => setActiveTab("Stats")}
          >
            Stats & Analytics
          </button>
          <button
            className={activeTab === "Analysis" ? "active" : ""}
            onClick={() => setActiveTab("Analysis")}
          >
            Analysis✨
          </button>
          <button
            className={activeTab === "Highlights" ? "active" : ""}
            onClick={() => setActiveTab("Highlights")}
          >
            Highlights
          </button>

          <button
            className={activeTab === "Box Scores" ? "active" : ""}
            onClick={() => setActiveTab("Box Scores")}
          >
            Box Scores
          </button>
          <button
            className={activeTab === "Bio" ? "active" : ""}
            onClick={() => setActiveTab("Bio")}
          >
            Bio
          </button>

          <button
            className={activeTab === "Intel" ? "active" : ""}
            onClick={() => setActiveTab("Intel")}
          >
            Intel
          </button>
          <button
            className={activeTab === "NIL" ? "active" : ""}
            onClick={() => setActiveTab("NIL")}
          >
            NIL
          </button>
        </div>
        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </PageContainer>
  );
};

export default SinglePlayer;
